var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_address_name"),
                    },
                    model: {
                      value: _vm.Name,
                      callback: function ($$v) {
                        _vm.Name = $$v
                      },
                      expression: "Name",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_address_name"),
                      inputValue: _vm.Name,
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_address"),
                    },
                    model: {
                      value: _vm.Email,
                      callback: function ($$v) {
                        _vm.Email = $$v
                      },
                      expression: "Email",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.email.email_address"),
                      inputValue: _vm.Email,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }